import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { contentListQueries } from '../../queries';
import { ModuleActionsService } from '../../services/moduleActionsService';
import { Toast } from 'src/shared/components/toast';
export const useRenameModuleMutation = (module) => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const renameModuleMutation = useMutation({
        mutationFn: async (name) => {
            if (module.name !== name) {
                return await ModuleActionsService.renameModule(module.id, name);
            }
        },
        onSuccess: (_, name) => {
            queryClient.setQueryData(contentListQueries.getModules({ extra: module.extra }).queryKey, (oldData) => oldData?.map((oldModule) => module.id === oldModule.id ? { ...oldModule, name } : oldModule));
            Toast.show({ type: 'success', message: t('content_list.rename_module.success') });
        },
        onError: () => {
            Toast.show({ type: 'danger', message: t('content_list.rename_module.success') });
        }
    });
    return renameModuleMutation;
};
